import { Routes } from '@angular/router';
import { Shell } from './layout/shell';
import { Redeem } from './features/redeem/redeem';
import { Showcode } from './features/showcode/showcode';
import { redeemWindowGuard } from './core/guards/redeem-window.guard';
import { redirectToShowCodeGuard } from './core/guards/redirect-to-show-code-guard';

export const routes: Routes = [
  {
    path: '',
    component: Shell,
    children: [
      {
        path: 'showcode/:merchantName',
        component: Showcode,
        canActivate: [redeemWindowGuard],
      },
      {
        path: '',
        component: Redeem,
        canActivate: [redirectToShowCodeGuard],
      },
      {
        path: ':merchantName',
        component: Redeem,
        canActivate: [redirectToShowCodeGuard],
      },
    ],
  },
];
